// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.edit-input[data-v-543e25bd] {\n  padding-right: 100px;\n}\n.cancel-btn[data-v-543e25bd] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
